var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.999488 67.472717c-245.505483 0-444.526259 199.021799-444.526259 444.527283s199.020776 444.526259 444.526259 444.526259S956.525748 757.505483 956.525748 512 757.504972 67.472717 511.999488 67.472717zM420.335812 677.177993 242.289744 677.177993 242.289744 499.131925l178.046069 0L420.335812 677.177993zM601.452823 373.271402 423.405731 373.271402 423.405731 195.225333l178.047092 0L601.452823 373.271402zM793.825179 677.177993 615.778086 677.177993 615.778086 499.131925l178.047092 0L793.825179 677.177993z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.221c21b03717b31926bdf80033fc1755.svg";
export { ForwardRef as ReactComponent };